{
  "dataFieldsInTooltip": {
    "title": "Object hover label",
    "tooltip": "Choose up to 5 attribute values to show when hovering over a map object.",
    "tooltipAttributeTypes": "Supported attribute types are: Text, Number, List and What3Words",
    "error": "Something has gone wrong, please contact support if the issue continues"
  },
  "tooltipShortcuts": {
    "select_object": "Press V",
    "draw": "Press D",
    "measure": "Press M",
    "undo": "Ctrl + Z",
    "redo": "Ctrl + Shift + Z",
    "comment": "Press C",
    "copy_paste": "Ctrl + C / Ctrl + V",
    "delete_object": "Press Del",
    "cancel_drawing": "Press Esc or Right Click",
    "confirm_drawing": "Press Enter or Double Click"
  },
  "draw": {
    "polygon": "Polygon",
    "line": "Line",
    "rectangle": "Rectangle",
    "routePlanner": "Route planner",
    "point": "Point",
    "model": "Model",
    "icon": "Icon"
  },
  "select": {
    "select_object": "Select object",
    "select_area": "Select objects within area"
  },
  "drawRoute": "Draw route",
  "drawLineRectangle": "Draw line rectangle",
  "layerOptionsTooltips": {
    "lock_layer": "Lock layer",
    "unlock_layer": "Unlock layer",
    "cannot_lock_layer_while_editing": "You cannot lock a layer whilst you are editing it"
  },
  "sitemapVersion": {
    "perimeter": "Perimeter",
    "drawOutsideCADPerimeter": "Cannot draw outside the boundary on this level"
  },
  "map_objects": "map objects",
  "map_object": "map object",
  "plan": "plan",
  "map_layer": "map layers",
  "layers": "layers",
  "layer": "layer",
  "layer_data_field": "layer data field",
  "layer_geoJson": "layer as geoJSON",
  "route_waypoints": "route waypoints",
  "map_objects_attribute_values": "map objects attribute values",
  "saved_map_view": "saved map view",
  "map_object_geometry": "map object geometry",
  "map_background": "map background",
  "map_sidebar_order": "map sidebar order",
  "map_comment": "map comment",
  "model": "model",
  "snapping": {
    "snapToDraw": "Snap to object"
  },
  "drawMapObjectTooltip": "Click to add another object to this layer",
  "exports2": {
    "title": "Title",
    "imageUpload": {
      "title": "Custom logo"
    }
  },
  "digitalTwin": {
    "occupiedTable": {
      "id": "Server ID",
      "status": "Status",
      "user": "User"
    },
    "status": {
      "Occupied": "In Use",
      "Available": "Available",
      "Starting": "Starting",
      "Stopped": "Stopped",
      "Error": "Error"
    },
    "occupiedPopup": {
      "header": "All digital twin servers are currently unavailable",
      "message": "Please try again later, or contact {{ supportEmail }} for more information"
    }
  },
  "fileUpload": {
    "invalid_compression_size": "The file you are trying to upload is too large and could not be compressed."
  }
}